import { render } from "./SgnTotalView.vue?vue&type=template&id=f89316f8"
import script from "./SgnTotalView.vue?vue&type=script&lang=js"
export * from "./SgnTotalView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__